import { defineMessages } from "react-intl";

/**
 * SFCC-11723 — i18n message catalog for the Learning Center levels block
 * (`learning-center-levels/*`): the level heading, module-card label, and
 * completion count.
 */
const messages = defineMessages({
  selectGoal: {
    id: "learningCenter.levels.select_goal",
    defaultMessage: "Please select a goal",
  },
  levelHeading: {
    id: "learningCenter.levels.level_heading",
    defaultMessage: "Level {levelNumber}: {title}",
  },
  moduleLabel: {
    id: "learningCenter.levels.module_label",
    defaultMessage: "Module {moduleNumber}:",
  },
  completeCount: {
    id: "learningCenter.levels.complete_count",
    defaultMessage: "{complete}/{total} Complete",
  },
});

export default messages;
